module.exports = __webpack_public_path__ + "static/media/unilever.5869882c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/unilever.jpg
// module id = 960
// module chunks = 0